<template>
  <div class="cw-form">
    <div style="text-align: right">
      <Print :print-value="printValue" @handleOn="handleOn" />
    </div>
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="详细信息" name="first">
          <el-scrollbar>
            <table style="width: 99%">
              <tr>
                <td colspan="2">
                  <h2 style="text-align: center">退 仓 单</h2>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  购货单位: {{ form.deliveryMessageInfo.fBillingName }}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  经营许可证号/备案凭证号:
                  {{ form.deliveryMessageInfo.fBusinessNo }}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  经营地址: {{ form.deliveryMessageInfo.fAddress_jy }}
                </td>
              </tr>
              <tr>
                <td style="width: 80%">
                  送货地址: {{ form.deliveryMessageInfo.fAddress_sh }}
                </td>
                <td>NO:{{ form.deliveryMessageInfo.fCkBillNo }}</td>
              </tr>
              <tr>
                <td style="width: 80%">
                  联系电话: {{ form.deliveryMessageInfo.fPhone }}
                </td>
                <td>日期:{{ form.deliveryMessageInfo.fDate }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <table class="tableDetails">
                    <tr>
                      <th>品名</th>
                      <th>规格</th>
                      <th>单位</th>
                      <th>数量</th>
                      <th>单价</th>
                      <th>金额</th>
                      <th>生产批号</th>
                      <th>生产日期</th>
                      <th>有效期（月）</th>
                      <th>备注</th>
                      <th>储运条件</th>
                      <th>注册证号/备案凭证编号</th>
                      <th>生产企业</th>
                      <th>生产企业许可证号/备案凭证编号</th>
                      <th>供货单位</th>
                    </tr>
                    <tr
                      v-for="(item, index) in form.deliveryMessageInfo.entrys"
                      :key="index"
                    >
                      <td>{{ item.fName }}</td>
                      <td>{{ item.fModel }}</td>
                      <td>{{ item.fUnit }}</td>
                      <td>{{ item.fQty }}</td>
                      <td>{{ item.fPrice_fh }}</td>
                      <td>{{ item.fTotal }}</td>
                      <td>{{ item.fBatchNo }}</td>
                      <td>{{ item.fDate_Sc }}</td>
                      <td>{{ item.fValidity }}</td>
                      <td>{{ item.fRetroactiveNo }}</td>
                      <td>{{ item.fTransportDes }}</td>
                      <td>{{ item.fRegisterNumber }}</td>
                      <td>{{ item.fProduction }}</td>
                      <td>{{ item.fProductionNumber }}</td>
                      <td>{{ item.fSupplier }}</td>
                    </tr>
                    <tr>
                      <td colspan="9">合 计</td>
                      <td colspan="6" style="text-align: left">
                        {{ form.deliveryMessageInfo.fAmount }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="确认" name="second">
          <el-form label-width="78px" style="overflow: auto">
            <el-form-item
              label="意见"
              style="margin-top: 10px"
              class="formitem"
            >
              <el-input
                v-model="form.procedureInfo.fOpinion"
                type="textarea"
                rows="4"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :disabled="saving"
                @click="submit(1)"
              >通过</el-button>
              <el-button
                type="warning"
                :disabled="saving"
                @click="submit(2)"
              >回退</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <iframe
        style="display: none"
      ><Print id="printVoucher" ref="printVoucher"></Print
        ></iframe>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'
import Print from '../commonPrint/printButton'

export default {
  inject: ['getMap'],
  components: { Print },

  data: function() {
    return {
      form: {
        fpInfo: {},
        procedureInfo: {},
        deliveryMessageInfo: { entrys: [] },
        procedureMessage: [],
        entrys: []
      },

      rules: {},
      printing: false,
      printValue: null,

      activeName: 'first',

      saving: false,
      loading: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {},
  methods: {
    fDwChange: function(item) {
      Object.assign(this.form.fpInfo, item)
    },

    sealChange: function(item) {
      this.form.fpInfo.fSealUrl = item.pictureUrl
    },

    submit: function(type) {
      this.$refs.form.validate(async(valid) => {
        this.form.procedureInfo.fType = type
        if (type == 2) {
          if (!this.form.procedureInfo.fOpinion) {
            this.activeName = 'second'
            this.$message.error('请填写审核意见')
            return
          }

          const h = this.$createElement
          this.form.procedureInfo.returnNode = await new Promise(
            (resolve, reject) => {
              this.$formDlg({
                title: '选择回退节点',
                formTpl: <ReturnNode name={'ReturnGoods_cw_q'}></ReturnNode>,
                formSubmit: resolve,
                width: '30%'
              })
            }
          )
        } else {
          this.form.procedureInfo.returnNode = null
          const flg = await this.$ask('是否提交?')
          if (!flg) return
        }

        this.saving = true
        this.$httpPost('SaleRetrun/SaleRetrunBillForCwq/SaleRetrunForCwqApproval', {
          datalist: JSON.stringify(this.form)
        })
          .then((res) => {
            if (!res.isSuccess) {
              this.$message.error(res.message)
              return
            }

            // 重新刷新页面数据
            this.$message.success(res.message)

            if (this.$route.query.ishome) {
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/' })
            } else {
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({
                path: '/SaleRetrun/SaleRetrunBillForCwq'
              })
            }
          })
          .finally(() => (this.saving = false))
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id

      this.loading = true
      const res = await this.$httpPost(
        'SaleRetrun/SaleRetrunBillForCwq/GetSaleRetrunBillForCwq',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    handleOn: function() {
      this.printValue = this.form.fid
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less">
.cw-form {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
<style lang="less" scoped>
.cw-form {
  .wlinfo {
    .el-input,
    .el-select,
    .el-autocomplete {
      width: 20% !important;
    }
  }

  .tableDetails {
    width: 100%;
    border-collapse: collapse;
  }

  .tableDetails,
  .tableDetails td,
  .tableDetails th {
    border: 1px solid black;
    text-align: center;
  }

  .tableDetails td,
  .tableDetails th {
    padding: 5px;
  }

  .imgYZ {
    width: 100px;
    height: 100px;
    border-width: 0px;
    vertical-align: middle;
  }
}
</style>
